/* eslint-disable array-callback-return */
import {
  Avatar,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Paper,
  Snackbar,
  Typography,
} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import TextFieldMUI from '@material-ui/core/TextField';
import {
  Apps,
  Clear,
  DoneOutline,
  Dvr,
  InsertLink,
  PictureAsPdf,
  PermMedia,
  Replay,
} from '@material-ui/icons';
import {Loading} from 'components/grid-dx/loading/loading';
import {i18n2} from 'features/i18n/i18n';
import {REMOVE_NOTIFICATION} from 'features/navigation/actions';
import {FastField, Field, Form, Formik} from 'formik';
import {TextField} from 'formik-material-ui';
import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import ImgSad from '../../../content/images/sad.png';
import ImgSmiley from '../../../content/images/smiley.png';
import {putIntoArrayAt} from '../../../helpers/functions.js';
import * as hooks from '../hookos/hooks';
import PDFDisplayer from './PDFDisplayer';
import MediaDisplayer from './MediaDisplayer';
import Test from './Test';
import Welcome from './Welcome';
import {Reasons} from 'app/Constants';
import {Enum} from 'components/Editors/GenericForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      flexGrow: 1,
    },
    root: {
      flexGrow: 1,
      display: 'flex',
      height: '100%',
      width: '100%',
      flexDirection: 'row',
      overflowX: 'hidden',
      overflowY: 'hidden',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch',
      alignContent: 'stretch',
      flexBasis: 'auto',
      alignSelf: 'auto',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    media: {
      width: '90%',
      height: '95%',
    },
    listItem: {
      maxWidth: 260,
      width: '100%',
      boxSizing: 'border-box',
    },
    listItemText: {
      flex: '1 1 auto',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '& .MuiListItemText-primary, & .MuiListItemText-secondary': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
      },
    },
    listItemIcon: {
      flex: '0 0 auto',
      marginLeft: theme.spacing(1),
    },
  }),
);

export const ContentTypes = {
  Link: 0,
  PDF: 1,
  Choice: 2,
  Signature: 3,
  LateReason: 4,
  Media: 5,
};

export const ContentStatus = {
  Undone: 0,
  DoneFailed: 1,
  DoneApproved: 2,
};

export const TestPassed = (props: any) => {
  let value = 0.0;
  if (props.score > 1) {
    value = props.score;
  } else {
    value = props.score * 100;
  }
  return (
    <Paper
      elevation={3}
      style={{
        textAlign: 'center',
        padding: '20px',
        minHeight: '80vh',
      }}>
      <div>
        <h1>{i18n2._('Cuestionario aprobado exitosamente')}</h1>
        <h2>
          {i18n2._('Último puntaje obtenido:')} {Math.round(value)}%
        </h2>
        <div style={{textAlign: 'center'}}>
          <img src={ImgSmiley} width={'100vh'} alt="Smiley" />
        </div>
      </div>
    </Paper>
  );
};

export const TestFailed = (props: any) => {
  let value = 0.0;
  if (props.score > 1) {
    value = props.score;
  } else {
    value = props.score * 100;
  }
  return (
    <Paper
      elevation={3}
      style={{
        textAlign: 'center',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        boxSizing: 'border-box',
      }}>
      <div>
        <h1>{i18n2._('Cuestionario desaprobado')}</h1>
        <h2>
          {i18n2._('Último puntaje obtenido:')} {Math.round(value)} %
        </h2>
        <div style={{textAlign: 'center'}}>
          <img src={ImgSad} width={'100vh'} alt="Sad" />
        </div>
        <p>{i18n2._('¿Desea volver a realizarlo?')}</p>
        <p>{i18n2._('El nuevo puntaje sobreescribrirá el último obtenido')}</p>
        <div style={{padding: '10px'}}>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => props.onReset()}
            endIcon={<Replay />}
            style={{padding: '10px'}}>
            {i18n2._('Volver a realizar cuestionario')}
          </Button>
        </div>
      </div>
    </Paper>
  );
};

export const LinkDisplayer = ({content}: {content: any}) => {
  return (
    <Paper
      elevation={3}
      style={{
        textAlign: 'center',
        height: '50vh',
        minHeight: '500px',
        padding: '20px',
      }}>
      <h1>{content.title}</h1>
      <h3>{content.description}</h3>
      <p>
        {i18n2._(
          'Para acceder a la documentación externa, pulse el siguiente enlace:',
        )}
      </p>
      <Link
        component="button"
        variant="body2"
        onClick={() => {
          window.open(content.links[0].url);
        }}
        style={{width: '90%'}}>
        <TextFieldMUI
          defaultValue={content.links[0].url}
          variant="outlined"
          fullWidth={true}
          inputProps={{style: {textAlign: 'center', color: '#60b39a'}}}
          InputProps={{readOnly: true}}
        />
      </Link>
    </Paper>
  );
};

const Online = (props: any) => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.authentication.user);
  const token = user.token;
  const classes = useStyles();
  const [contents, setContents] = useState([]);
  const [content, setContent] = useState<{
    current: any;
    displayer: number;
    ix: number;
  }>({
    current: {},
    displayer: -1,
    ix: -1,
  });
  const [choiceMessage, setChoiceMessage] = useState({
    active: false,
    message: '',
  });
  const [done, setDone] = useState<any[number]>([]);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(true);
  const [courseFinished, setCourseFinished] = useState({
    active: false,
    score: 0,
    approved: false,
    message: '',
  });
  // const loadContents = hooks.getCourseContents(props.data.iD_Course, props.data.iD_Instance, user.name, token)

  React.useEffect(() => {
    hooks
      .getCourseContents(
        props.data.iD_Course,
        props.data.iD_Instance,
        user.name,
        token,
      )
      .then((data: any) => {
        setContents(data);
        let contentStatuses = data.reduce(
          (acc: Array<number>, content: any) => acc.concat(content.approved),
          [],
        );
        setDone(contentStatuses);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPDFQuery = () => {
    const url = '/CourseManager/GetCoursePDF';
    return (
      url +
      `?ID_PDF=${content.current.pdFs[0].iD_PDF}&ID_Content=${content.current.iD_Content}&ID_Course=${content.current.iD_Course}`
    );
  };

  const getMediaQuery = () => {
    const url = '/CourseManager/GetCourseMedia';
    return (
      url +
      `?ID=${content.current.medias[0].iD_Media}&ID_Content=${content.current.iD_Content}&ID_Course=${content.current.iD_Course}`
    );
  };

  const updateContentScore = (score: number) => {
    let newContent = {...content};
    newContent.current.score = score;
    setContent(newContent);
  };

  const submitCourse = (values: any, resetForm: any) => {
    hooks
      .updateAttempt(
        props.data.iD_Course,
        props.data.iD_Instance,
        user.name,
        values.pass,
        token,
        values.lateReason,
        values.descriptionLateReason,
      )
      .then((response) => {
        if (response.ok) {
          response
            .json()
            .then((data) => {
              setCourseFinished({
                active: true,
                score: data * 100,
                approved: true,
                message: `${i18n2._('Curso terminado con puntaje')} ${
                  data * 100
                }%`,
              });
            })
            .catch((error) =>
              console.error(
                'Error on JSON deserealize from /UpdateAttempt',
                error,
              ),
            );
        } else {
          response.text().then((respMessage) => {
            setCourseFinished({
              active: true,
              score: 0,
              approved: false,
              message: respMessage,
            });
            resetForm();
          });
        }
      });
  };

  const updateReadableContent = (content: any) => {
    hooks
      .initContent(
        content.iD_Course,
        content.iD_Content,
        props.data.iD_Instance,
        user.name,
        content.type,
        token,
      )
      .then(() => {});
  };

  return (
    <>
      <div className={classes.root}>
        {typeof props.data === 'undefined' ||
        typeof props.data.iD_Course === 'undefined' ||
        redirect ? (
          <Redirect to={{pathname: './Dashboard'}} />
        ) : loading ? (
          <Loading />
        ) : (
          <Grid
            container
            className={classes.grid}
            spacing={2}
            style={{height: '100vh', overflow: 'hidden'}}>
            <Grid
              item
              xs={2}
              container
              spacing={2}
              wrap="nowrap"
              style={{
                width: '20%',
                overflow: 'hidden',
              }}>
              <div
                style={{
                  position: 'sticky',
                  top: '8vh', // mantiene el margen superior
                  paddingBottom: '2vh',
                }}>
                <List
                  component="nav"
                  aria-label="content"
                  className="thinScroll"
                  style={{
                    overflow: 'hidden',
                    borderRadius: 8,
                  }}>
                  {contents.map((data: any, ix: number) => {
                    if (data.type === ContentTypes.Link) {
                      return (
                        <ListItem
                          className={classes.listItem}
                          key={ix}
                          button
                          onClick={() => {
                            setContent({
                              current: data,
                              displayer: ContentTypes.Link,
                              ix: ix,
                            });
                            setDone(
                              putIntoArrayAt(
                                ContentStatus.DoneApproved,
                                done,
                                ix,
                              ),
                            );
                            updateReadableContent(data);
                          }}>
                          <ListItemAvatar>
                            <Avatar style={{background: '#4040a1'}}>
                              <InsertLink style={{color: '#FFFFFF'}} />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={data.title}
                            secondary={data.description}
                            className={classes.listItemText}
                          />
                          {done[ix] === ContentStatus.DoneApproved ? (
                            <ListItemIcon style={{justifyContent: 'center'}}>
                              <DoneOutline style={{color: 'green'}} />
                            </ListItemIcon>
                          ) : (
                            <></>
                          )}
                        </ListItem>
                      );
                    }
                    if (data.type === ContentTypes.PDF) {
                      return (
                        <ListItem
                          className={classes.listItem}
                          key={ix}
                          button
                          onClick={() => {
                            setContent({
                              current: data,
                              displayer: ContentTypes.PDF,
                              ix: ix,
                            });
                            setDone(
                              putIntoArrayAt(
                                ContentStatus.DoneApproved,
                                done,
                                ix,
                              ),
                            );
                            updateReadableContent(data);
                          }}>
                          <ListItemAvatar>
                            <Avatar style={{background: '#4040a1'}}>
                              <PictureAsPdf style={{color: '#FFFFFF'}} />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={data.title}
                            secondary={data.description}
                            className={classes.listItemText}
                          />
                          {done[ix] === ContentStatus.DoneApproved ? (
                            <ListItemIcon style={{justifyContent: 'center'}}>
                              <DoneOutline style={{color: 'green'}} />
                            </ListItemIcon>
                          ) : (
                            <></>
                          )}
                        </ListItem>
                      );
                    }

                    if (data.type === 3) {
                      return (
                        <ListItem
                          className={classes.listItem}
                          key={ix}
                          button
                          onClick={() => {
                            setContent({
                              current: data,
                              displayer: ContentTypes.Media,
                              ix: ix,
                            });
                            setDone(
                              putIntoArrayAt(
                                ContentStatus.DoneApproved,
                                done,
                                ix,
                              ),
                            );
                            updateReadableContent(data);
                          }}>
                          <ListItemAvatar>
                            <Avatar style={{background: '#4040a1'}}>
                              <PermMedia style={{color: '#FFFFFF'}} />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={data.title}
                            secondary={data.description}
                            className={classes.listItemText}
                          />
                          {done[ix] === ContentStatus.DoneApproved ? (
                            <ListItemIcon style={{justifyContent: 'center'}}>
                              <DoneOutline style={{color: 'green'}} />
                            </ListItemIcon>
                          ) : (
                            <></>
                          )}
                        </ListItem>
                      );
                    }

                    if (data.type === ContentTypes.Choice)
                      return (
                        <ListItem
                          className={classes.listItem}
                          key={ix}
                          button
                          onClick={() => {
                            setContent({
                              current: data,
                              displayer: ContentTypes.Choice,
                              ix: ix,
                            });
                          }}>
                          <ListItemAvatar>
                            <Avatar style={{background: '#4040a1'}}>
                              <Apps style={{color: '#FFFFFF'}} />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={data.title}
                            secondary={data.description}
                            className={classes.listItemText}
                          />
                          {done[ix] === ContentStatus.DoneApproved ? (
                            <ListItemIcon className={classes.listItemIcon}>
                              <DoneOutline style={{color: 'green'}} />
                            </ListItemIcon>
                          ) : done[ix] === ContentStatus.DoneFailed ? (
                            <ListItemIcon className={classes.listItemIcon}>
                              <Clear style={{color: 'red'}} />
                            </ListItemIcon>
                          ) : (
                            <></>
                          )}
                        </ListItem>
                      );
                  })}
                  <ListItem
                    className={classes.listItem}
                    button
                    onClick={() => {
                      setContent({
                        current: {},
                        displayer: ContentTypes.Signature,
                        ix: -1,
                      });
                    }}
                    disabled={
                      done.includes(ContentStatus.DoneFailed) ||
                      done.includes(ContentStatus.Undone)
                    }>
                    <ListItemAvatar>
                      <Avatar style={{background: '#4040a1'}}>
                        <Dvr style={{color: '#FFFFFF'}} />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={i18n2._('Firma')}
                      secondary={i18n2._('Confirmación del curso')}
                      className={classes.listItemText}
                    />
                  </ListItem>
                </List>
              </div>
            </Grid>
            <Grid
              item
              xs={10}
              style={{
                height: '100vh',
                overflowY: 'auto',
                paddingTop: '4vh',
                paddingBottom: '2vh',
                paddingLeft: '4vh',
              }}>
              {content.displayer === ContentTypes.Link ? (
                <LinkDisplayer content={content.current} />
              ) : content.displayer === ContentTypes.PDF ? (
                <PDFDisplayer file={getPDFQuery()} />
              ) : content.displayer === ContentTypes.Media ? (
                <div className={classes.media}>
                  <MediaDisplayer
                    file={getMediaQuery()}
                    route={content.current.medias[0].route}
                  />
                </div>
              ) : content.displayer === ContentTypes.Choice ? (
                done[content.ix] === ContentStatus.DoneApproved ? (
                  <TestPassed
                    onReset={() =>
                      setDone(
                        putIntoArrayAt(ContentStatus.Undone, done, content.ix),
                      )
                    }
                    score={content.current.score}
                  />
                ) : done[content.ix] === ContentStatus.DoneFailed ? (
                  <TestFailed
                    onReset={() =>
                      setDone(
                        putIntoArrayAt(ContentStatus.Undone, done, content.ix),
                      )
                    }
                    score={content.current.score}
                  />
                ) : (
                  <Test
                    approved={(score: number) => {
                      setDone(
                        putIntoArrayAt(
                          ContentStatus.DoneApproved,
                          done,
                          content.ix,
                        ),
                      );
                      updateContentScore(score);
                    }}
                    failed={(score: number) => {
                      setDone(
                        putIntoArrayAt(
                          ContentStatus.DoneFailed,
                          done,
                          content.ix,
                        ),
                      );
                      updateContentScore(score);
                    }}
                    data={{
                      content: content.current,
                      iD_Course: props.data.iD_Course,
                      cwid: user.name,
                      iD_Instance: props.data.iD_Instance,
                      token: token,
                    }}
                  />
                )
              ) : content.displayer === ContentTypes.Signature ? (
                <Paper
                  elevation={3}
                  style={{
                    textAlign: 'center',
                    height: '70vh',
                    padding: '20px',
                    overflow: 'auto',
                  }}>
                  <Typography variant="h3">
                    {i18n2._('Finalización de curso')}
                  </Typography>
                  <Typography variant="h4">
                    {i18n2._(
                      'Ingrese sus credenciales para firmar su asistencia',
                    )}
                  </Typography>
                  <Formik
                    initialValues={{
                      user: user.name,
                      pass: '',
                      reason: '',
                      lateReason: null,
                      descriptionLateReason: '',
                    }}
                    onSubmit={(values: any, {resetForm}) =>
                      submitCourse(values, resetForm)
                    }
                    validateOnChange
                    enableReinitialize>
                    {(formikProps) => (
                      <Form>
                        <Grid container spacing={2}>
                          {props.data.expired && (
                            <>
                              <Grid item sm={6} xs={12} style={{padding: 20}}>
                                <Enum
                                  data={Reasons}
                                  type="text"
                                  label={i18n2._('Razon de tardanza')}
                                  field="lateReason"
                                  disabled={false}
                                  fullWidth={true}
                                  variant="standard"
                                  customValidate={(value: any) => {
                                    let error;
                                    if (!value && value !== 0) {
                                      error = i18n2._(
                                        'Elija razón de tardanza',
                                      );
                                    }
                                    return error;
                                  }}
                                />
                              </Grid>
                              <Grid item sm={6} xs={12} style={{padding: 20}}>
                                {formikProps.values.lateReason === 4 && (
                                  <FastField
                                    label={i18n2._('Descripción')}
                                    name={'descriptionLateReason'}
                                    variant="standard"
                                    size="small"
                                    fullWidth
                                    component={TextField}
                                    type="text"
                                    validate={(value: any) => {
                                      let error;
                                      if (!value) {
                                        error = i18n2._(
                                          'Detalle la razón de la tardanza',
                                        );
                                      }
                                      return error;
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                )}
                              </Grid>
                            </>
                          )}
                          <Grid item sm={6} xs={12} style={{padding: 20}}>
                            <Field
                              label={i18n2._('User')}
                              name={'user'}
                              variant="standard"
                              size="small"
                              fullWidth
                              component={TextField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled={true}
                            />
                          </Grid>
                          <Grid item sm={6} xs={12} style={{padding: 20}}>
                            <FastField
                              label={i18n2._('Password')}
                              name={'pass'}
                              variant="standard"
                              size="small"
                              fullWidth
                              component={TextField}
                              type="password"
                              validate={(value: any) => {
                                let error;
                                if (!value) {
                                  error = i18n2._('Please provide a password');
                                }
                                return error;
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <div
                              style={{
                                textAlign: 'center',
                                marginBottom: '10px',
                              }}>
                              <Button
                                type="submit"
                                disabled={formikProps.isSubmitting}
                                variant="contained"
                                color="primary">
                                {i18n2._('Firmar')}
                              </Button>
                            </div>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Paper>
              ) : (
                <Paper
                  elevation={3}
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    minHeight: '80vh',
                  }}>
                  <Welcome
                    message={i18n2._('Bienvenido al curso')}
                    subtitle=""
                  />
                </Paper>
              )}
            </Grid>
          </Grid>
        )}
        <Snackbar
          open={choiceMessage.active}
          autoHideDuration={1000}
          onClose={() => setChoiceMessage({active: false, message: ''})}
          message={i18n2._(choiceMessage.message ? choiceMessage.message : '')}
        />
        <Snackbar
          open={courseFinished.active}
          autoHideDuration={1000}
          onClose={() => {
            if (courseFinished.approved) {
              dispatch({
                type: REMOVE_NOTIFICATION,
                payload: {
                  id_instance: props.data.iD_Instance,
                  id_course: props.data.iD_Course,
                },
              });
              setRedirect(true);
            } else {
              setCourseFinished({
                active: false,
                score: 0,
                approved: false,
                message: '',
              });
            }
          }}
          message={i18n2._(
            courseFinished.message ? courseFinished.message : '',
          )}
        />
      </div>
    </>
  );
};

export default Online;
